import { useQuery } from '@tanstack/react-query';

import getRfq from '../api/getRfq';

const useRfq = (rfqId?: string) => {
  return useQuery({
    queryKey: ['rfq', rfqId],
    queryFn: () => getRfq(rfqId as string),
    enabled: !!rfqId
  });
};

export default useRfq;
